import type { MenuContextValue } from '@components/tiptap/tiptap-ui-primitive/menu/menu-types'
import { createContext, useContext } from 'react'

export const SearchableContext = createContext<boolean>(false)

export const MenuContext = createContext<MenuContextValue>({
  isRootMenu: false,
  open: false,
})

export const useSearchableContext = (): boolean => {
  return useContext(SearchableContext)
}

export const useMenuContext = (): MenuContextValue => {
  return useContext(MenuContext)
}
